<template>
    <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-70"
        enter-to-class="transform opacity-100"
        leave-active-class="transition ease-in duration-50"
        leave-from-class="transform opacity-100"
        leave-to-class="transform opacity-70"
    >
        <div
            v-if="value"
            class="w-full h-full"
            :class="['app-overlay', overlayClass]"
        >
            <transition
                enter-active-class="transition ease-out duration-500"
                enter-from-class="transform translate-y-full"
                enter-to-class="transform translate-y-0"
                leave-active-class="transition ease-in duration-250"
                leave-from-class="transform translate-y-0"
                leave-to-class="transform translate-y-full"
            >
                <div
                    v-if="showContent"
                    class="
                        flex flex-col
                        w-full
                        h-full
                        max-w-2xl
                        mx-auto
                        bottom-sheet
                    "
                    :class="{ 'overflow-y-auto': scrollable }"
                >
                    <div
                        class="flex-auto"
                        :style="{ minHeight: spaceTopComputed }"
                        @click="clickAway()"
                    >
                        <!-- emp space -->
                    </div>
                    <div
                        class="rounded-t-28px shadow relative bottom-sheet"
                        :class="[bgComputed]"
                    >
                        <slot></slot>
                        <template
                            v-if="!!$slots['dismiss'] || dismissable == true"
                        >
                            <div class="absolute right-6 top-6">
                                <template v-if="!dismissable">
                                    <slot
                                        name="dismiss"
                                        :on="{ click: hide }"
                                    ></slot>
                                </template>
                                <template v-else>
                                    <img
                                        src="@/assets/icon/dialog/close.svg"
                                        @click="hide()"
                                    />
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
import PropsHelper from "@/helper/PropsHelper";

export default {
    name: "BottomSheet",
    props: {
        modelValue: {
            type: Boolean,
        },
        hideOverlay: {
            type: Boolean,
            default: false,
        },
        overlayClass: {
            type: String,
            default: "overlay-dark",
        },
        bg: {
            type: String,
            default: undefined,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        persistent: { type: Boolean },
        spaceTop: {
            type: [Number, String],
            default: 80,
        },
        dismissable: { type: Boolean },
    },
    emits: ["onClose", "update:modelValue"],
    data: function () {
        return {
            showContent: false,
        };
    },
    computed: {
        value: {
            get: function () {
                return this.modelValue;
            },
            set: function (newVal) {
                this.$emit("update:modelValue", newVal);
            },
        },
        bgComputed: function () {
            return PropsHelper.getStringProp(this.bg) || "bg-white";
        },
        spaceTopComputed: function () {
            return PropsHelper.getBoxUnit(this.spaceTop);
        },
    },
    watch: {
        value: function (val) {
            if (val) {
                this.disableScroll();
                this.$nextTick(() => {
                    this.showContent = true;
                });
            } else {
                this.enableScroll();
            }
        },
        showContent: function (val) {
            if (!val) {
                setTimeout(() => {
                    this.value = false;
                }, 250);
            }
        },
    },
    beforeUnmount: function () {
        this.enableScroll();
    },
    methods: {
        show: function () {
            this.value = true;
        },
        hide: function () {
            this.showContent = false;
            this.$emit("onClose");
        },
        clickAway: function () {
            if (!this.persistent) {
                this.hide();
            }
        },
        disableScroll: function () {
            // modern Chrome requires { passive: false } when adding event
            // https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily
            // var supportsPassive = false;
            // try {
            //     window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            //         get: function () {
            //             supportsPassive = true;
            //             return true
            //         }
            //     }));
            // } catch (e) {
            //     // do nothing
            // }

            // var wheelOpt = supportsPassive ? { passive: false } : false;
            // var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

            // window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
            // window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
            // window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
            // window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
            // window.onscroll = function () { window.scrollTo(0, 0); };
            // var x = window.scrollX;
            // var y = window.scrollY;
            // window.onscroll = function () { window.scrollTo(x, y); };
            document.body.classList.add("not-scroll");
        },
        enableScroll: function () {
            // window.onscroll = function () { };
            document.body.classList.remove("not-scroll");
        },
        preventDefault: function (e) {
            e.preventDefault();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.bottom-sheet {
    z-index: $zindex-modal;
}
</style>
